var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { mapGetters, mapActions } from 'vuex';
import { CART, MENU_ITEMS, LOCATION, MENU_OPTIONS, MENU_OPTION_EXCEPTIONS } from '@/stores/defs';
import { couponService } from '@/services/coupon.service';
import cartService from '@/services/cart.service';
import { forEach, map, reduce, pullAt, compact, filter, includes, find, findIndex, flatMap, groupBy, uniqBy, cloneDeep, } from 'lodash';
// @ts-ignore
import EventBus from '@EventBus';
import DiscountReferenceModel from '@/models/DiscountReferenceModel';
import optionService from '@/services/option.service';
var couponMixin = {
    data: function () {
        return {
            coupon: null,
            message: '',
        };
    },
    computed: __assign({}, mapGetters({
        getCoupon: CART.GET_COUPON,
        getCartItems: CART.ITEMS,
        getMenuItem: MENU_ITEMS.GET_ITEM,
        menuItems: MENU_ITEMS.GET_MAP,
        couponItems: CART.COUPON_ITEMS,
        getLocation: LOCATION.GET_LOCATION,
        choicesForOption: MENU_OPTIONS.GET_CHOICES,
        getOptionException: MENU_OPTION_EXCEPTIONS.GET_FOR_ITEM,
        menuId: MENU_ITEMS.GET_MENU_ID
    })),
    methods: __assign({}, mapActions({
        setCoupon: CART.SET_COUPON,
        updateCartItem: CART.UPDATE_ITEM,
    }), { messageForCouponType: function () {
            var coupon = this.coupon;
            var message = '';
            if (coupon) {
                message = coupon.messageForTarget();
            }
            return message;
        },
        getAvailableRedemptionsTxt: function () {
            var coupon = this.coupon;
            var message = '';
            if (coupon) {
                var maxRedemptions = coupon.maxRedemptions;
                if (!coupon.isBogo && 0 <= maxRedemptions) {
                    var discountUses = this.getDiscountUses(coupon);
                    var redemptionsAvailable = maxRedemptions - discountUses;
                    if (maxRedemptions === 0) {
                        message += 'Unlimited Redemptions Available';
                    }
                    else if (redemptionsAvailable) {
                        message += " Redemptions Available: " + redemptionsAvailable;
                    }
                }
            }
            return message;
        },
        useCoupon: function (code) {
            var _this = this;
            var location = this.getLocation;
            var locationBase = location.id;
            var menuId = this.menuId;
            couponService.fetchCoupon(locationBase, code, menuId, function (response) {
                _this.message = response.message;
                _this.coupon = response.coupon;
                if (_this.coupon) {
                    _this.coupon.codeName = code;
                    _this.message = _this.messageForCouponType();
                }
                EventBus.$emit('update-coupon-display');
            });
        },
        resetDiscountedItems: function () {
            var coupon = this.getCoupon;
            if (!coupon) {
                return;
            }
            var items = this.getCartItems;
            forEach(items, function (item) {
                item.removeDiscount(coupon);
            });
        },
        itemMatchesForCoupon: function (item, discount, ignoreQuantity) {
            if (ignoreQuantity === void 0) { ignoreQuantity = false; }
            var items = couponService.getItemsFromDiscount(discount);
            var couponItems = this.itemsInCoupon(items);
            var matches = cartService.findMatches([item], couponItems, ignoreQuantity);
            return (matches.length >= 1);
        },
        itemsInCoupon: function (items) {
            var _this = this;
            var couponItems = map(items, function (item) {
                var menuItem = _this.getMenuItem(item.asset_id) || _this.getMenuItem(item.parent_asset_id);
                if (!menuItem) {
                    return null;
                }
                var cartItem = cartService.prepareItem(menuItem);
                return cartItem;
            });
            return compact(couponItems);
        },
        resetReferences: function (items) {
            forEach(items, function (item) {
                item.referenceIds = null;
            });
        },
        addReferenceToItem: function (item, quantityIndex, discount) {
            var key = item.index + "-" + quantityIndex;
            var reference = new DiscountReferenceModel({
                referenceId: key,
                discountId: discount.id,
            });
            if (!item.referenceIds) {
                item.referenceIds = [];
            }
            item.referenceIds.push(reference);
        },
        generateReferences: function (matches, items, discountId) {
            var _loop_1 = function (i) {
                var match = matches[i];
                var item = find(items, function (matchItem) {
                    return matchItem.index === match;
                });
                var quantityIndex = item.quantity - (i + 1);
                this_1.addReferenceToItem(item, quantityIndex, {
                    id: discountId,
                });
            };
            var this_1 = this;
            // reference ids need to be attached to all the items
            // associated with a coupon
            for (var i = 0; i < matches.length; i++) {
                _loop_1(i);
            }
            return items;
        },
        getReferenceIndices: function (itemIndex, matches, minItemCount) {
            var removeItemIndex = findIndex(matches, function (match) {
                return match === itemIndex;
            });
            pullAt(matches, removeItemIndex);
            matches.length = minItemCount - 1;
            matches.push(itemIndex);
            return matches;
        },
        itemsWithoutDiscounts: function (cartItems) {
            var _this = this;
            var filteredItems = filter(cartItems, function (item) {
                return (_this.getItemDiscountTotal(item) === 0);
            });
            return filteredItems;
        },
        findSpecialsWithDiscount: function (discountId) {
            var menuItems = this.menuItems;
            var matchingSpecials = filter(menuItems, function (item) {
                if (item.isBundle()) {
                    var discount = item.discount;
                    return (discount.id === discountId);
                }
                return false;
            });
            return uniqBy(matchingSpecials, 'name');
        },
        itemsFromIndices: function (indices, _items) {
            var items = _items || this.cartItems;
            var indexedItems = filter(items, function (item) {
                if (includes(indices, item.index)) {
                    return true;
                }
                return false;
            });
            return indexedItems;
        },
        itemSatisfiesDiscount: function (item, cartOptions, discount) {
            if (!this.itemMatchesForCoupon(item, discount)) {
                return false;
            }
            var group = discount.groups[0];
            var exceptionsMap = group.getItemOptionExceptionsMap();
            var exception = exceptionsMap[item.id] || exceptionsMap[item.parentAssetId];
            if (exception) {
                var storeLevelExceptionOption_1 = optionService.convertToOptionExceptionModel(__assign({}, exception, { hydrationStrategy: "hydrateForCoupon" }));
                // convert ids of options to local ids
                if (!discount.isLocal) {
                    storeLevelExceptionOption_1.convertFranchiseOptionIdsToLocal();
                }
                var foundOption = find(cartOptions, function (option) { return storeLevelExceptionOption_1.id === option.id; });
                if (!item.satisfiesException(storeLevelExceptionOption_1, foundOption.choices)) {
                    return false;
                }
            }
            return true;
        },
        filterItemsWithMasterOption: function (discount, items) {
            // TODO groups is an array and this is only pulling the first item
            // is it possible to have more than 1 group for a discount?
            var group = discount.groups[0];
            var exceptionsMap = group.getItemOptionExceptionsMap();
            var filteredItems = filter(items, function (item) {
                var itemId = item.parentAssetId;
                var rawException = exceptionsMap[item.parentAssetId] || exceptionsMap[item.id];
                // block checks if our choice is included
                if (rawException) {
                    var storeLevelExceptionOption = optionService.convertToOptionExceptionModel(__assign({}, rawException, { hydrationStrategy: "hydrateForCoupon" }));
                    if (storeLevelExceptionOption) {
                        // check if item satisfies an exception
                        if (!item.satisfiesException(storeLevelExceptionOption)) {
                            return false;
                        }
                    }
                }
                // create method on item to get choice check if included is false, if so return false
                if (!rawException) {
                    return true;
                }
                rawException['hydrationStrategy'] = 'hydrateForCoupon';
                var exception = optionService.convertToOptionExceptionModel(rawException);
                var includedDefaults = exception.getIncludedDefaultChoiceIds();
                var choicesForMaster = item.getChoiceIdsForOption(exception.id);
                if (includes(includedDefaults, choicesForMaster[0])) {
                    return true;
                }
                return false;
            });
            return filteredItems;
        },
        handleItemsForBogo: function (discount, matches, filteredItems) {
            var minItemCount = discount.minItemCount;
            var itemIndex = -1;
            var discountId = discount.id;
            itemIndex = cartService.findMostExpensiveRunnerup(filteredItems, matches);
            this.getCartItems[itemIndex].addDiscount(discount);
            var referenceIndices = this.getReferenceIndices(itemIndex, matches, minItemCount);
            var matchGroups = groupBy(referenceIndices);
            for (var key in matchGroups) {
                if (matchGroups.hasOwnProperty(key)) {
                    var group = matchGroups[key];
                    this.generateReferences(group, filteredItems, discountId);
                }
            }
            return itemIndex;
        },
        handleStandardCoupon: function (filteredItems, matches, discount) {
            var itemIndex = cartService.findMostExpensive(filteredItems, matches);
            this.getCartItems[itemIndex].addDiscount(discount);
            return itemIndex;
        },
        handleRedeemAll: function (discount, matchedItems) {
            forEach(matchedItems, function (item) {
                item.removeAllDiscounts();
                for (var i = 0; i < item.quantity; i++) {
                    item.addDiscount(discount);
                }
            });
            return 0;
        },
        splitMatchedItems: function (matchedItems) {
            var splitMatches = [];
            forEach(matchedItems, function (item) {
                if (item.quantity === 1) {
                    var cloneItem = cloneDeep(item);
                    splitMatches.push(cloneItem);
                }
                else {
                    for (var i = 0; i < item.quantity; i++) {
                        var cloneItem = cloneDeep(item);
                        cloneItem.quantity = 1;
                        cloneItem.cachedPrice = null;
                        splitMatches.push(cloneItem);
                    }
                }
            });
            return splitMatches;
        },
        handleItemsForMultiBogo: function (discount, matchedItems) {
            var maxRedemptions = discount.maxRedemptions;
            var minItemCount = discount.minItemCount;
            var itemIndex = (matchedItems.length >= minItemCount) ? 0 : -1;
            var splitMatches = this.splitMatchedItems(matchedItems);
            splitMatches = cartService.sortMostExpensiveItems(splitMatches);
            var currentItem = 0;
            var currentRedemption = 0;
            var cartItems = this.getCartItems;
            if (maxRedemptions === 0) {
                maxRedemptions = splitMatches.length / minItemCount;
            }
            while (splitMatches.length > 0) {
                var match = splitMatches.shift();
                if (currentRedemption >= maxRedemptions) {
                    continue;
                }
                var item = cartItems[match.index];
                this.addReferenceToItem(item, currentItem, discount);
                currentItem++;
                if (currentItem % minItemCount === 0) {
                    cartItems[match.index].addDiscount(discount);
                    currentRedemption++;
                    currentItem = 0;
                }
            }
            return itemIndex;
        },
        countReferencesForItems: function (items) {
            var referenceCount = reduce(items, function (accumulator, item) {
                var referenceIds = item.referenceIds;
                if (!referenceIds) {
                    return accumulator;
                }
                return accumulator += referenceIds.length;
            }, 0);
            return referenceCount;
        },
        countItems: function (items) {
            var itemCount = reduce(items, function (accumulator, item) {
                return accumulator += item.quantity;
            }, 0);
            return itemCount;
        },
        applyDiscountToCartItems: function (discount) {
            var _this = this;
            var items = couponService.getItemsFromDiscount(discount);
            var cartItems = this.getCartItems;
            var indexedItems = cartService.indexItems(cartItems);
            this.resetDiscountedItems();
            if (items) {
                this.setCoupon(discount);
            }
            if (items.length === 0) {
                return [-1];
            }
            var couponItems = this.itemsInCoupon(items);
            var nonDiscountedItems = this.itemsWithoutDiscounts(indexedItems);
            var filteredItems = this.filterItemsWithMasterOption(discount, nonDiscountedItems);
            var matches = cartService.findMatches(filteredItems, couponItems);
            if (matches.length === 0) {
                return [-1];
            }
            this.resetReferences(indexedItems);
            var minItemCount = discount.minItemCount;
            var maxRedemptions = discount.maxRedemptions;
            var matchedItems = this.itemsFromIndices(matches);
            var itemIndex = -1;
            var isBogo = (minItemCount > 1);
            var redeemOnce = (maxRedemptions === 1);
            var isMultiRedemption = (maxRedemptions > 1);
            var isUnlimitedRedemption = (maxRedemptions === 0);
            if (isBogo && matches.length >= minItemCount) {
                if (redeemOnce) {
                    itemIndex = this.handleItemsForBogo(discount, matches, filteredItems);
                }
                if (isUnlimitedRedemption) {
                    itemIndex = this.handleItemsForMultiBogo(discount, matchedItems, matches);
                }
                if (isMultiRedemption) {
                    var refCount = this.countReferencesForItems(matchedItems);
                    var usedRedemptions = refCount / minItemCount;
                    if (usedRedemptions < maxRedemptions) {
                        itemIndex = this.handleItemsForMultiBogo(discount, matchedItems, matches);
                    }
                }
                return itemIndex;
            }
            // find index of next matching item without discount and apply discount
            var applyDiscount = function () {
                var index = cartService.findNextItemWithoutDiscount(filteredItems, matches, discount);
                if (index !== -1) {
                    _this.getCartItems[index].addDiscount(discount);
                }
                return index;
            };
            // Default standard apply to most expensive item
            if (!isBogo && !isUnlimitedRedemption) {
                if (isMultiRedemption) {
                    var discountUses = this.getDiscountUses(discount);
                    var redemptionsAvailable = maxRedemptions - discountUses;
                    var indexes = [];
                    // apply discounts until no more items available
                    // -1 in array indicates we still have redemption available to use
                    for (var i = 0; i < redemptionsAvailable; i++) {
                        var index = applyDiscount();
                        if (index || index === 0) {
                            indexes.push(index);
                        }
                    }
                    if (indexes.length) {
                        return indexes;
                    }
                }
                else {
                    itemIndex = applyDiscount();
                }
            }
            if (isUnlimitedRedemption && !isBogo) {
                itemIndex = this.handleRedeemAll(discount, matchedItems);
            }
            return [itemIndex];
        },
        getItemsInCoupon: function (discount) {
            var _this = this;
            var items = couponService.getItemsFromDiscount(discount);
            if (items.length === 0) {
                if (!discount) {
                    return [];
                }
                return this.findSpecialsWithDiscount(discount.id);
            }
            // TODO implementation should be more intelligent
            // editing items implementation
            var menuItems = map(items, function (item) {
                var cartItem = cartService.convertToCartItem(item, _this.menuItems);
                if (!cartItem) {
                    return null;
                }
                return _this.getMenuItem(cartItem.id);
            });
            return compact(menuItems);
        },
        getHighestPriceInCoupon: function (coupon) {
            var items = this.getItemsInCoupon(coupon);
            var price = 0;
            forEach(items, function (item) {
                price = Math.max(price, +item.price);
            });
            return price;
        },
        hasDiscountedItems: function () {
            var numberOfDiscounts = this.getNumberOfDiscountsInCart();
            return (numberOfDiscounts > 0);
        },
        getNumberOfDiscountsInCart: function () {
            var items = this.getCartItems;
            var discounts = map(items, function (item) {
                var discounts = item.discounts;
                if (discounts) {
                    return (discounts.length);
                }
                return 0;
            });
            var numberOfDiscounts = reduce(discounts, function (sum, discountLength) {
                return sum + discountLength;
            });
            return numberOfDiscounts;
        },
        getDiscountUses: function (discount) {
            var items = this.cartItems;
            return reduce(items, function (accum, item) {
                if (item.discounts) {
                    item.discounts.forEach(function (itemDiscount) {
                        if (itemDiscount.id === discount.id) {
                            accum++;
                        }
                    });
                }
                return accum;
            }, 0);
        },
        getApplicableCartItems: function (_coupon) {
            var items = this.getCartItems;
            var coupon = this.coupon || _coupon;
            var couponItems = this.getItemsInCoupon(coupon);
            var itemIds = map(couponItems, 'id');
            var applicableItems = filter(items, function (item) {
                if (includes(itemIds, item.id)) {
                    return true;
                }
                return false;
            });
            return applicableItems;
        },
        removeCouponFromAllItems: function (coupon) {
            var _this = this;
            var items = this.getCartItems;
            forEach(items, function (item) {
                item.removeDiscount(coupon);
                _this.updateCartItem(item);
            });
        },
        removeCoupon: function () {
            var coupon = this.coupon;
            if (!coupon) {
                return;
            }
            this.removeCouponFromAllItems(coupon);
            var cartItems = this.getCartItems;
            this.resetReferences(cartItems);
            this.setCoupon(null);
        },
        satisfyItemToDiscount: function (itemId, options, discount) {
            var _this = this;
            if (discount) {
                var discountOption = discount.getOptionsInDiscount();
                if (discountOption) {
                    discountOption = discountOption[0];
                    var optionExceptionModel_1 = optionService.convertToOptionExceptionModel(__assign({}, discountOption.option_exception, { hydrationStrategy: 'hydrateForCoupon' }));
                    if (!discount.isLocal) {
                        optionExceptionModel_1.convertFranchiseOptionIdsToLocal();
                    }
                    options.forEach(function (option) {
                        if (option.exclusive) {
                            // exclusive
                            var choice = (option.choices.length) ? option.choices[0] : { id: "" };
                            var defaultChoice = optionExceptionModel_1.masterOption.defaultChoices[(choice.id || "") + "-"];
                            if (option.id === optionExceptionModel_1.masterOption.id && ((defaultChoice && !defaultChoice.included) || !defaultChoice)) {
                                var _loop_2 = function (id) {
                                    if (optionExceptionModel_1.masterOption.defaultChoices[id].included) {
                                        var menuChoices = _this.choicesForOption(option.id);
                                        var foundChoice = find(menuChoices, function (_choice) {
                                            return optionExceptionModel_1.masterOption.defaultChoices[id].id === _choice.id;
                                        });
                                        // get option by the option id,
                                        // use the choice map to get the actual price and choice 
                                        var itemOptionException = _this.getOptionException(itemId);
                                        var storeExceptionChoice = (itemOptionException && itemOptionException.masterOption) ?
                                            itemOptionException.masterOption.defaultChoices[(foundChoice.id || "") + "-"] : null;
                                        option.addChoice(cartService.prepareChoice(__assign({}, foundChoice, (storeExceptionChoice && { priceDelta: storeExceptionChoice.priceDelta }))));
                                        return "break";
                                    }
                                };
                                for (var id in optionExceptionModel_1.masterOption.defaultChoices) {
                                    var state_1 = _loop_2(id);
                                    if (state_1 === "break")
                                        break;
                                }
                            }
                        }
                        else {
                            // remove choices that are not included in the exception
                            option.choices.forEach(function (choice) {
                                var defaultChoice = optionExceptionModel_1.masterOption.defaultChoices["1-" + choice.id];
                                if (defaultChoice && !defaultChoice.included) {
                                    option.removeChoice(choice);
                                }
                            });
                        }
                    });
                }
            }
            return options;
        },
        // TODO: move to service
        getFlattenedItemExceptions: function (items) {
            var _this = this;
            var itemIds = flatMap(items, 'id');
            var exceptions = map(itemIds, function (id) {
                var itemExceptions = _this.getOptionException(id);
                if (itemExceptions) {
                    return itemExceptions;
                }
                return null;
            });
            return exceptions || [];
        },
        getDiscountPriceForItem: function (discount, item) {
            var optionExceptions = [];
            if (item.bundle) {
                optionExceptions = this.getFlattenedItemExceptions(item.bundle.items);
            }
            else {
                optionExceptions = this.getOptionException(item.id);
            }
            return discount.discountPriceForItem(item, optionExceptions);
        },
        getDiscountTotal: function () {
            var _this = this;
            var cartItems = this.getCartItems;
            var totals = reduce(cartItems, function (accumulator, item) {
                var itemDiscountTotal = _this.getItemDiscountTotal(item);
                return accumulator + itemDiscountTotal;
            }, 0);
            return totals;
        },
        getItemDiscountTotal: function (item) {
            var _this = this;
            return reduce(item.discounts, function (accum, discount) {
                return accum + _this.getDiscountPriceForItem(discount, item);
            }, 0);
        } }),
};
export default couponMixin;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/couponMixin.ts
// module id = null
// module chunks = 